const initialState = {
  loading: true,
  alerts: {},
  error: "",
};

const availableAlertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ALERT_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "FETCH_ALERT_SUCCESS":
      return {
        loading: false,
        alerts: action.payload,
        error: "",
      };
    case "FETCH_ALERT_FAILURE":
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { availableAlertsReducer }